module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-auto-template/src/templates/loader.html -->\n<svg\n  class="spinner"\n  width="65px"\n  height="65px"\n  viewBox="0 0 66 66"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <circle\n    class="path"\n    fill="none"\n    stroke-width="6"\n    stroke-linecap="round"\n    cx="33"\n    cy="33"\n    r="30"\n  ></circle>\n</svg>\n';
}
return __p;
};
